import { cn } from 'src/lib/utils';
import {
  PortalDsBadge,
  type PortalDsBadgeVariant,
} from 'src/components/portal-design-system';
import type { EtlRollupStatus } from '../types/operations.types';
import {
  ROLLUP_STATUS_LABELS,
  rollupStatusFromRawStatus,
} from '../helpers/etl-health.helpers';

type Props = {
  status: string | EtlRollupStatus | null | undefined;
  className?: string;
};

const ROLLUP_VARIANTS: Record<EtlRollupStatus, PortalDsBadgeVariant> = {
  green: 'green',
  yellow: 'amber',
  red: 'red',
  no_data: 'gray',
};

function rawStatusToVariant(status: string): PortalDsBadgeVariant {
  const normalised = status.toLowerCase();
  if (['pass', 'success', 'healthy', 'green', 'complete'].includes(normalised)) {
    return 'green';
  }
  if (['warning', 'warn', 'yellow', 'review', 'paused'].includes(normalised)) {
    return 'amber';
  }
  if (['fail', 'failed', 'error', 'red', 'investigate'].includes(normalised)) {
    return 'red';
  }
  if (['running', 'queued', 'live'].includes(normalised)) {
    return 'blue';
  }
  return 'gray';
}

export function EtlHealthStatusPillV2({ status, className }: Props) {
  const rollupStatus: EtlRollupStatus = typeof status === 'string'
    && ['green', 'yellow', 'red', 'no_data'].includes(status)
    ? status as EtlRollupStatus
    : rollupStatusFromRawStatus(status);

  const label = typeof status === 'string'
    && !['green', 'yellow', 'red', 'no_data'].includes(status)
    ? status
    : ROLLUP_STATUS_LABELS[rollupStatus];

  const variant = typeof status === 'string'
    && !['green', 'yellow', 'red', 'no_data'].includes(status)
    ? rawStatusToVariant(status)
    : ROLLUP_VARIANTS[rollupStatus];

  return (
    <PortalDsBadge variant={variant} pill className={className}>
      {label}
    </PortalDsBadge>
  );
}
